import Header from '../../components/admin/header/Header';

import Write from '../../components/admin/event/Write';

export default function NoticeWrite() {
  return (
    <>
      <Header></Header>
        <Write />
    </>
  );
}
